import { addDays } from 'date-fns';
export default {
  data() {
    return {
      dateRangeOptions: {
        startDate: '2019-01-03',
        endDate: '2019-02-02',
        format: 'DD/MM/YYYY',
        //maxDate: format(new Date()+1000 * 60 * 60 * 24 * 30, 'YYYY-MM-DD'),  
        maxDate: this.makeComputerDate(addDays(new Date(), 30)),
        presets: [
          {
            label: 'Today',
            range: [
              this.makeComputerDate(new Date()), //start date. YYYY-MM-DD
              this.makeComputerDate(new Date()), // end date. YYYY-MM-DD
            ],
          },
          {
            label: 'Last 15 days',
            range: [
              this.makeComputerDate(addDays(new Date(), -15)), //start date. YYYY-MM-DD
              this.makeComputerDate(new Date()), // end date. YYYY-MM-DD
            ],
          },
          {
            label: 'Last 30 days + Next 30 days',
            range: [
              this.makeComputerDate(addDays(new Date(), -30)), //start date. YYYY-MM-DD
              this.makeComputerDate(addDays(new Date(), 30)),
            ],
          },
        ]
      },
    }
  }
}